import { ScreenType } from 'layouts/dashboard'
import { forwardRef } from 'react'

import { Avatar, AvatarProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'

// ----------------------------------------------------------------------

type AvatarColor = 'default' | 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error'

// ----------------------------------------------------------------------

export interface MAvatarProps extends AvatarProps {
  color?: AvatarColor
  backgroundColor?: string
  screenType?: ScreenType
}

const MAvatar = forwardRef<HTMLDivElement, MAvatarProps>(
  ({ color = 'default', backgroundColor, children, sx, screenType, ...other }, ref) => {
    const theme = useTheme()

    if (color === 'default') {
      return (
        <Avatar ref={ref} sx={sx} {...other}>
          {children}
        </Avatar>
      )
    }

    return (
      <Avatar
        ref={ref}
        sx={{
          fontWeight: theme.typography.fontWeightMedium,
          color: backgroundColor ? 'white' : theme.palette[color].contrastText,
          background: backgroundColor ?? theme.palette[color].contrastText,
          width: screenType === 'mobile' ? theme.spacing(8) : theme.spacing(7),
          height: screenType === 'mobile' ? theme.spacing(8) : theme.spacing(7),
          ...sx,
        }}
        {...other}
      >
        {children}
      </Avatar>
    )
  }
)

export default MAvatar
